import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import {
  StrapiLinkDTO,
  LinkDTO,
} from "@lib/strapi/dtos/components/shared/link.dto";

export interface StrapiLinksSectionDTO extends StrapiDynamicZoneComponentDTO {
  title: string;
  links: StrapiLinkDTO[];
}

export class LinksSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  title: string;
  links: LinkDTO[];
}
